import React from 'react'
import styled from 'styled-components'

const StyledCaseData = styled.div`
  color: #4f4f4f;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  width: 60%;
  line-height: 1.35;
  margin: 5rem 0 5rem;
  z-index: 2;
  position: relative;
  @media (max-width: 1250px) {
    width: 100%;
  }
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.7rem 0;
`

const Label = styled.div`
  width: 100px;
  margin-right: 60px;
  opacity: 0.6;
  @media (max-width: 1250px) {
    margin-right: 30px;
  }
`

const Text = styled.div`
  width: calc(100% - 160px);
  @media (max-width: 1250px) {
    width: calc(100% - 130px);
  }
`

const CaseData = ({ description, year, roles }) => (
  <StyledCaseData>
    <Row>
      <Label>Description:</Label>
      <Text>{description}</Text>
    </Row>
    <Row>
      <Label>Year:</Label>
      <Text>{year}</Text>
    </Row>
    <Row>
      <Label>Role:</Label>
      <Text>{roles}</Text>
    </Row>
  </StyledCaseData>
)

export default CaseData
